export default __webpack_public_path__ + "images/65d75a544137805ec81b1759b3884ea6.png";